import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {injectIntl} from "react-intl";

import {discountInterface, discountSectionsInterface} from "./discounstInterface";
import DiscountCommon from "./discountCommon";
import {setDiscountSections, setFinanceActiveDiscount} from "../../actions/priceWorksheetActions";
import {shouldUseMultipleWorkSheets} from "./discountFunctions";

class DiscountAdd extends DiscountCommon {

  static propTypes = {
    discount: PropTypes.shape(discountInterface),
    discountSection: PropTypes.shape(discountSectionsInterface),
  };

  approvePersonSelectHandle = (event) => {
    const approveObject = this.props.discount.approveOptions ? JSON.parse(this.props.discount.approveOptions) : {};
    this.setDiscountProperty("approveOptions", JSON.stringify({...approveObject,
      selectedOption: event.target.value
    }));
  }

  render() {
    const {discount, intl} = this.props;
    const disabled = this.isDiscountDisabled();

    // if (!discount.approveOptions) {
    //   discount.approveOptions = '{"options":["John Connor","Mathew Perry","Loui Vitton"]}';
    // }

    const approveOptions = discount.approveOptions ? JSON.parse(discount.approveOptions) : null;

    return (
      <li className={"discount" + (discount.selected ? " discount--special" : "")
      + (disabled ? " discount--disabled" : "")}>
        {/*<div className="add-section" onClick={this.addCustomDiscountClick}>*/}
        {/*  <div className="add-section-header">*/}
        {/*    <span className="add-section-header__plus">+</span>*/}
        {/*    <div className="add-section-header__title">*/}
        {/*      /!*<FormattedMessage id="shoppingCart.discounts.addCustomDiscount"/>*!/*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*  <div className="add-section-body">*/}
        {/*    <span className="add-section-body__sidebar"/>*/}
        {/*    <span className="add-section-body__content"/>*/}
        {/*  </div>*/}
        {/*</div>*/}
        {/*<div className="discount discount--special">*/}
          <div className="discount-cell discount-cell--select">
            <button className={"ui-checkbox" + (discount.selected ? " ui-checkbox--checked" : "")}
                    onClick={this.handleDiscountSelectClick}/>
          </div>
          <div className="discount-cell discount-cell--special-name">
            {discount.selected
              ? <input className="ui-input discount-special__name"
                       value={discount.name}
                       onChange={(event) => this.setDiscountProperty("name", event.target.value)}/>
              : null}
            {discount.selected && approveOptions && approveOptions.options && approveOptions.options.length ? (
              <select name=""
                      className={"ui-input discount-special__name discount-special__select margin-l-16"
                        + (approveOptions.selectedOption ? "" : " discount-special__select--empty")}
                      value={approveOptions.selectedOption || "placeholder"}
                      required={true}
                      onChange={this.approvePersonSelectHandle}>
                <option value="placeholder" disabled hidden>
                  {intl.formatMessage({id: "shoppingCart.discounts.selectApprovePerson"})}
                </option>
                {approveOptions.options.map((option, optionIndex) => {
                  return <option key={optionIndex + option} value={option}>{option}</option>
                })}
              </select>
            ) : null}
          </div>
        <div className="discount-cell discount-cell--special-amount">
          {approveOptions && !approveOptions.selectedOption ? null : this.renderAmountInput()}
        </div>
          {/*<div className="discount-cell discount-cell--delete">*/}
          {/*  <button className="ui-close discount-special__delete" onClick={this.addCustomDiscountClick}/>*/}
          {/*</div>*/}
        {/*</div>*/}
      </li>
    )
  }
}

const mapStateToProps = (store) => {
  const {discountSections, customAddedDiscounts, workSheetsCount, financeActiveDiscount} = store.priceWorksheetState;
  const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex, quotes} = store.quotesState;
  const {jobIsSaving} = store.serverState;

  return {
    discountSections,
    customAddedDiscounts,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorData: store.fabricatorState,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    fabricatorSettings: store.fabricatorState.settings,
    // Total requirements end
    allWizardsValues,
    activeQuoteIndex,
    workSheetsCount,
    quotes,
    hasMultipleWorkSheets: shouldUseMultipleWorkSheets(workSheetsCount),
    jobIsSaving,
    financeActiveDiscount,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
  setFinanceActiveDiscount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(DiscountAdd)
);
